import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=7314094a&scoped=true&"
var script = {}
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=7314094a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7314094a",
  null
  
)

export default component.exports